// The single Archive group every archived client is lifted into. A negative id
// can never collide with a real paymentGroupId, so the panel's key stays unique.
export const ARCHIVE_GROUP_ID = -1;
export const ARCHIVE_GROUP_NAME = 'ARCHIVE';

export const clientManagerServiceMessages = {
  CLIENTS: {
    GET_ERROR: 'Unable to load clients. Please try again.',
    GET_DETAILS_ERROR: 'Unable to load this client. Please try again.',
    CREATE_ERROR: 'Unable to create client. Please try again.',
    UPDATE_ERROR: 'Unable to update client. Please try again.',
    ARCHIVE_ERROR: 'Unable to archive client. Please try again.',
    RESTORE_ERROR: 'Unable to restore client. Please try again.',
    DELETE_ERROR: 'Unable to delete client. Please try again.',
    CREATE_PAYMENT_GROUP_ERROR: 'Unable to create payment group. Please try again.',
  },
};
